import script from "./FieldControlFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldControlFile.vue?vue&type=script&setup=true&lang=ts"

import "./FieldControlFile.vue?vue&type=style&index=0&id=20979b7a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20979b7a"]])

export default __exports__